export default __webpack_public_path__ + "2c223fea86a0f277524bd689c8e937ab.png";